import { SortDirection } from 'dy-frontend-http-repository/lib/data/enums';

const timeTrackingSortItemsInformation: { [key in string]: string } = {
    [`last_entry_at${SortDirection.DESC}`]: 'Recent',
    [`last_entry_at${SortDirection.ASC}`]: 'Oldest',
    [`state_latest_transition_at${SortDirection.DESC}`]: 'Latest state transition - newest first',
    [`state_latest_transition_at${SortDirection.ASC}`]: 'Latest state transition - recent first',
    [`total_duration_min${SortDirection.DESC}`]: 'Time spent - most spent first',
    [`total_duration_min${SortDirection.ASC}`]: 'Priority - less spent first',
};

export default timeTrackingSortItemsInformation;
